import { useDashboard } from '@/features/Dashboard/api';
import { useMarketsList } from '@/features/Markets';

export const useInitialAppQueries = (enabled: boolean) => {
  const { isSuccess: isMarketsSuccess, isError: isMarketsError } = useMarketsList(
    undefined,
    enabled
  );
  const { isSuccess: isDashboardsSuccess, isError: isDashboardsError } = useDashboard(enabled);

  return {
    areMarketsDone: isMarketsSuccess || isMarketsError,
    areDashboardsDone: isDashboardsSuccess || isDashboardsError
  };
};
